const StringConstants = {
  // http method types
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete',

  // for MUI
  ZILLOW_BRAND: 'zillow',

  // Proxy paths for APIs
  PROXY_PATH: 'rental-manager/growth/proxy/',
  RG_PROXY_PATH: 'rental-manager/growth/growth-proxy/',

  // api
  RENTAL_MANAGER_API_V1_PREFIX: 'rental-manager-api/api/v1',

  // links
  ZILLOW_URL: 'https://www.zillow.com',
  ZILLOW_LIST_HOME_FOR_RENT: 'https://www.zillow.com/rental-manager/properties?postingPath=true',
  ZILLOW_PRICE_MY_RENTAL_PATH: 'https://www.zillow.com/rental-manager/price-my-rental/',

  // strings
  ZILLOW_ERROR_COPY: 'Return to the Price My Rental tool',
};

export default StringConstants;
